import React, { createContext, useState, useEffect } from "react";
import {
  viewRoleDetail,
  deleteRoleApi,
  getrolenFeatureApi,
} from "../../../api/Api";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import { useCookies } from "react-cookie";
import { handleApiError } from "../../../constants/Constants";

export const RoleManageViewContext = createContext({});
export const RoleManageContextProvider = ({ children }) => {
  const location = useLocation();
  const [roleData, setRoleData] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState(false);
  const [statusMessagePopup, setStatusMessagePopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [adminCatergoryList, setAdminCategoryList] = useState([]);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [featuresData, setFeaturesData] = useState([]);
  const [userPermissionList, setUserPermissionList] = useState([]);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const roleId = location?.state?.id;
  const navigate = useNavigate();
  const currentPage = location?.state?.page;
  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "66f50472b58f398ba8f04a8b";
  })[0];

  const viewRole = async (id) => {
    try {
      setSpinnerStatus(true);
      const getDetailData = await viewRoleDetail(id);
      if (getDetailData.status === 200) {
        setSpinnerStatus(false);
        setErrorPopup(false);
        setRoleData(getDetailData.data.data.role);
        setUserPermissionList(getDetailData?.data?.data?.role?.permissions);
      }
    } catch (error) {
      if (error?.status === 404) {
        setErrorPopupMessage("");
        setErrorPopup(false);
        roleTableList();
      } else {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText
        );
      }
      setSpinnerStatus(false);
    }
  };

  const deleteRoleManage = async (id) => {
    try {
      setSpinnerStatus(true);
      const getrole = await deleteRoleApi(id);
      if (getrole.data.statusCode === 200) {
        setDeleteAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(getrole.data.message);
      }
    } catch (error) {
      setDeletePopup(false);
      setDeleteAlert(false);
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const dataUserPermissionList = async () => {
    try {
      setSpinnerStatus(true);
      const featureApiData = await getrolenFeatureApi();

      setFeaturesData(featureApiData?.data?.data);
    } catch (error) {
      setDeletePopup(false);
      setDeleteAlert(false);
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  useEffect(() => {
    viewRole(roleId);
    dataUserPermissionList();
  }, []);

  const roleToLogin = () => {
    removeCookie("x-access-token");
    navigator(RouteConstants.LOGIN);
  };

  const roleTableList = () => {
    navigate(RouteConstants.ROLE_LIST, { state: { page: currentPage } });
  };

  const editRoleData = (id) => {
    navigate(RouteConstants.EDIT_ROLE, { state: { id, page: currentPage } });
  };

  const providerValue = {
    roleData,
    deletePopup,
    errorPopup,
    errorPopupMessage,
    setDeletePopup,
    setStatusPopup,
    setStatusMessagePopup,
    spinnerStatus,
    statusPopup,
    productCategoryList,
    setSuccessPopup,
    successPopup,
    categoryData,
    successPopupMessage,
    deleteRoleManage,
    setErrorPopup,
    roleId,
    roleTableList,
    roleToLogin,
    viewRole,
    statusValue,
    buttonText,
    isEdit,
    editRoleData,
    deleteAlert,
    setDeleteAlert,
    featuresData,
    userPermissionList,
    permissionAccess,
  };
  return (
    <RoleManageViewContext.Provider value={providerValue}>
      {children}
    </RoleManageViewContext.Provider>
  );
};
